import {Locale} from "./models/locale";
import {enUS} from "@mui/x-date-pickers/locales";

// Locale is pinned to en-US. The gogo-patient API this was written against had
// no localization — it ignored X-Language and always answered in English — so
// the locale picker was removed rather than left as a control that does nothing.
//
// This stays a Locale (not a bare string) because App.tsx feeds `.code` and
// `.muiLocaleText` into MUI's LocalizationProvider for date formatting.
//
// To restore multi-locale: re-add the es-MX entry with esES localeText, restore
// getLocaleFromLanguage + the localStorage seed in AppStateStore, and re-mount
// LocaleSelector in App.tsx. Only worth doing once cc12ih4jy4 is confirmed to
// serve localized content.
export const DEFAULT_LOCALE = new Locale(
    'en-US',
    'English (US)',
    enUS.components.MuiLocalizationProvider.defaultProps.localeText
);
